{
  "actionButtons": {
    "deselectAll": "deselectAll",
    "export": "export",
    "exportAsCsv": "exportAsCsv",
    "exportAsPdf": "exportAsPdf",
    "selectAll": "selectAll"
  },
  "areYouSureModal": {
    "cancelText": "cancelText",
    "confirmText": "confirmText",
    "title": "title"
  },
  "columnManager": {
    "columns": "columns",
    "hiddenColumns": "hiddenColumns",
    "noColumnsMatch": "noColumnsMatch",
    "pinnedColumns": "pinnedColumns",
    "searchPlaceholder": "Buscar columnas...",
    "visibleColumns": "visibleColumns"
  },
  "coordinates": {
    "latitude": "latitude",
    "latitudePlaceholder": "latitudePlaceholder",
    "latitudeTooltip": "latitudeTooltip",
    "longitude": "longitude",
    "longitudePlaceholder": "longitudePlaceholder",
    "longitudeTooltip": "longitudeTooltip"
  },
  "copy": "{{text}} copiado al portapapeles",
  "countries": {
    "AC": "Ascension Island",
    "AD": "Andorra",
    "AE": "United Arab Emirates",
    "AF": "Afghanistan",
    "AG": "Antigua and Barbuda",
    "AI": "Anguilla",
    "AL": "Albania",
    "AM": "Armenia",
    "AO": "Angola",
    "AQ": "Antarctica",
    "AR": "Argentina",
    "AS": "American Samoa",
    "AT": "Austria",
    "AU": "Australia",
    "AW": "Aruba",
    "AX": "Åland Islands",
    "AZ": "Azerbaijan",
    "BA": "Bosnia and Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Belgium",
    "BF": "Burkina Faso",
    "BG": "Bulgaria",
    "BH": "Bahrain",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "Saint Barthélemy",
    "BM": "Bermuda",
    "BN": "Brunei",
    "BO": "Bolivia",
    "BQ": "Caribbean Netherlands",
    "BR": "Brazil",
    "BS": "Bahamas",
    "BT": "Bhutan",
    "BV": "Bouvet Island",
    "BW": "Botswana",
    "BY": "Belarus",
    "BZ": "Belize",
    "CA": "Canada",
    "CC": "Cocos (Keeling) Islands",
    "CD": "Congo (Kinshasa)",
    "CF": "Central African Republic",
    "CG": "Congo (Brazzaville)",
    "CH": "Switzerland",
    "CI": "Ivory Coast",
    "CK": "Cook Islands",
    "CL": "Chile",
    "CM": "Cameroon",
    "CN": "China",
    "CO": "Colombia",
    "CP": "Clipperton Island",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cape Verde",
    "CW": "Curaçao",
    "CX": "Christmas Island",
    "CY": "Cyprus",
    "CZ": "Czech Republic",
    "DE": "Germany",
    "DG": "Diego Garcia",
    "DJ": "Djibouti",
    "DK": "Denmark",
    "DM": "Dominica",
    "DO": "Dominican Republic",
    "DZ": "Algeria",
    "EA": "Ceuta and Melilla",
    "EC": "Ecuador",
    "EE": "Estonia",
    "EG": "Egypt",
    "EH": "Western Sahara",
    "ER": "Eritrea",
    "ES": "Spain",
    "ET": "Ethiopia",
    "EU": "European Union",
    "FI": "Finland",
    "FJ": "Fiji",
    "FK": "Falkland Islands",
    "FM": "Micronesia",
    "FO": "Faroe Islands",
    "FR": "France",
    "GA": "Gabon",
    "GB": "United Kingdom",
    "GD": "Grenada",
    "GE": "Georgia",
    "GF": "French Guiana",
    "GG": "Guernsey",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GL": "Greenland",
    "GM": "Gambia",
    "GN": "Guinea",
    "GP": "Guadeloupe",
    "GQ": "Equatorial Guinea",
    "GR": "Greece",
    "GS": "South Georgia and the South Sandwich Islands",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HK": "Hong Kong SAR China",
    "HM": "Heard & McDonald Islands",
    "HN": "Honduras",
    "HR": "Croatia",
    "HT": "Haiti",
    "HU": "Hungary",
    "IC": "Canary Islands",
    "ID": "Indonesia",
    "IE": "Ireland",
    "IL": "Israel",
    "IM": "Isle of Man",
    "IN": "India",
    "IO": "British Indian Ocean Territory",
    "IQ": "Iraq",
    "IR": "Iran",
    "IS": "Iceland",
    "IT": "Italy",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordan",
    "JP": "Japan",
    "KE": "Kenya",
    "KG": "Kyrgyzstan",
    "KH": "Cambodia",
    "KI": "Kiribati",
    "KM": "Comoros",
    "KN": "St. Kitts & Nevis",
    "KP": "North Korea",
    "KR": "South Korea",
    "KW": "Kuwait",
    "KY": "Cayman Islands",
    "KZ": "Kazakhstan",
    "LA": "Laos",
    "LB": "Lebanon",
    "LC": "St. Lucia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Liberia",
    "LS": "Lesotho",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "LV": "Latvia",
    "LY": "Libya",
    "MA": "Morocco",
    "MC": "Monaco",
    "MD": "Moldova",
    "ME": "Montenegro",
    "MF": "St. Martin",
    "MG": "Madagascar",
    "MH": "Marshall Islands",
    "MK": "North Macedonia",
    "ML": "Mali",
    "MM": "Myanmar (Burma)",
    "MN": "Mongolia",
    "MO": "Macao SAR China",
    "MP": "Northern Mariana Islands",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Mauritius",
    "MV": "Maldives",
    "MW": "Malawi",
    "MX": "Mexico",
    "MY": "Malaysia",
    "MZ": "Mozambique",
    "NA": "Namibia",
    "NC": "New Caledonia",
    "NE": "Niger",
    "NF": "Norfolk Island",
    "NG": "Nigeria",
    "NI": "Nicaragua",
    "NL": "Netherlands",
    "NO": "Norway",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "New Zealand",
    "OM": "Oman",
    "PA": "Panama",
    "PE": "Peru",
    "PF": "French Polynesia",
    "PG": "Papua New Guinea",
    "PH": "Philippines",
    "PK": "Pakistan",
    "PL": "Poland",
    "PM": "St. Pierre & Miquelon",
    "PN": "Pitcairn Islands",
    "PR": "Puerto Rico",
    "PS": "Palestinian Territories",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguay",
    "QA": "Qatar",
    "RE": "Réunion",
    "RO": "Romania",
    "RS": "Serbia",
    "RU": "Russia",
    "RW": "Rwanda",
    "SA": "Saudi Arabia",
    "SB": "Solomon Islands",
    "SC": "Seychelles",
    "SD": "Sudan",
    "SE": "Sweden",
    "SG": "Singapore",
    "SH": "St. Helena",
    "SI": "Slovenia",
    "SJ": "Svalbard & Jan Mayen",
    "SK": "Slovakia",
    "SL": "Sierra Leone",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somalia",
    "SR": "Suriname",
    "SS": "South Sudan",
    "ST": "São Tomé & Príncipe",
    "SV": "El Salvador",
    "SX": "Sint Maarten",
    "SY": "Syria",
    "SZ": "Eswatini",
    "TA": "Tristan da Cunha",
    "TC": "Turks & Caicos Islands",
    "TD": "Chad",
    "TF": "French Southern Territories",
    "TG": "Togo",
    "TH": "Thailand",
    "TJ": "Tajikistan",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turkmenistan",
    "TN": "Tunisia",
    "TO": "Tonga",
    "TR": "Turkey",
    "TT": "Trinidad & Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzania",
    "UA": "Ukraine",
    "UG": "Uganda",
    "UM": "U.S. Outlying Islands",
    "UN": "Desconocido",
    "US": "United States",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VA": "Vatican City",
    "VC": "St. Vincent & Grenadines",
    "VE": "Venezuela",
    "VG": "British Virgin Islands",
    "VI": "U.S. Virgin Islands",
    "VN": "Vietnam",
    "VU": "Vanuatu",
    "WF": "Wallis & Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Yemen",
    "YT": "Mayotte",
    "ZA": "South Africa",
    "ZM": "Zambia",
    "ZW": "Zimbabwe"
  },
  "countriesEcobalyse": {
    "BD": "BD",
    "CN": "CN",
    "FR": "FR",
    "IN": "IN",
    "KH": "KH",
    "MA": "MA",
    "MM": "MM",
    "PK": "PK",
    "RAF": "RAF",
    "RAS": "RAS",
    "REE": "REE",
    "REO": "REO",
    "RLA": "RLA",
    "RME": "RME",
    "RNA": "RNA",
    "ROC": "ROC",
    "TN": "TN",
    "TR": "TR",
    "VN": "VN"
  },
  "dataLoad": {
    "error": {
      "message": "No hemos podido recuperar los datos solicitados. Por favor, recargue la página.",
      "title": "Se ha producido un error"
    },
    "noResults": {
      "message": "No se encontraron datos relacionados con su empresa. Por favor, inténtelo de nuevo más tarde.",
      "title": "Sin resultados"
    }
  },
  "documentUpload": {
    "helptext": "Tamaño máximo: {{ maxSize }} MB",
    "missingDocument": "missingDocument",
    "title": "Arrastre sus archivos aquí o haga clic para seleccionar manualmente",
    "uploadSuppliers": "uploadSuppliers"
  },
  "error": {
    "default": "Se ha producido un error",
    "message": "message",
    "title": "title"
  },
  "fabricProcess": {
    "knitting-circular": "knitting-circular",
    "knitting-fully-fashioned": "knitting-fully-fashioned",
    "knitting-integral": "knitting-integral",
    "knitting-mix": "knitting-mix",
    "knitting-straight": "knitting-straight",
    "weaving": "weaving"
  },
  "filter": "filter",
  "form": {
    "reset": "reset",
    "save": "save"
  },
  "languages": {
    "arabic": "Árabe",
    "belarusian": "Bielorruso",
    "chinese": "Chino",
    "dutch": "Neerlandés",
    "english": "Inglés",
    "french": "Francés",
    "german": "Alemán",
    "italian": "Italiano",
    "japanese": "Japonés",
    "korean": "Coreano",
    "lithuanian": "Lituano",
    "portuguese": "Portugués",
    "romanian": "Rumano",
    "spanish": "Español",
    "turkish": "Turco"
  },
  "lists": {
    "noData": {
      "title": "Sin datos"
    }
  },
  "menus": {
    "admin": "Administrador",
    "businessPartners": "Socios comerciales",
    "certificates": "Certificados",
    "communicationStudio": "Studio",
    "dashboard": "Panel de control",
    "dataTransfer": "Transferencia de datos",
    "faq": "Preguntas frecuentes",
    "invoices": "invoices",
    "logout": "Cerrar sesión",
    "products": "Productos",
    "profile": "profile",
    "regulations": "regulations"
  },
  "showOnlyMainFabric": "showOnlyMainFabric",
  "simulation": {
    "notSubscribed": {
      "message": "message",
      "title": "title"
    }
  },
  "sort": {
    "ascending": "Ascendente",
    "descending": "Descendente",
    "search": {
      "placeholder": "Buscar para ordenar"
    },
    "title": "Ordenar"
  },
  "success": {
    "message": "Acción completada con éxito",
    "title": "Éxito"
  },
  "supplier": {
    "footer": {
      "privacyPolicy": "privacyPolicy"
    },
    "menu": {
      "contacts": "Contactos",
      "documentation": "Preguntas frecuentes y Guía del usuario",
      "loggedAs": "Has iniciado sesión como",
      "productionSites": "Sitios de Producción",
      "requests": "Solicitudes de Clientes",
      "supplierRequests": "Seguimiento de Proveedores"
    }
  },
  "table": {
    "filter": {
      "date": {
        "preset": {
          "custom": "custom",
          "oneMonthAgo": "oneMonthAgo",
          "oneMonthFromNow": "oneMonthFromNow",
          "oneWeekAgo": "oneWeekAgo",
          "oneWeekFromNow": "oneWeekFromNow",
          "oneYearAgo": "oneYearAgo",
          "oneYearFromNow": "oneYearFromNow",
          "today": "today",
          "tomorrow": "tomorrow",
          "yesterday": "yesterday"
        }
      },
      "operator": {
        "after": "after",
        "afterOrEquals": "afterOrEquals",
        "before": "before",
        "beforeOrEquals": "beforeOrEquals",
        "between": "between",
        "empty": "empty",
        "equals": "equals",
        "isEmpty": "isEmpty",
        "isNotEmpty": "isNotEmpty",
        "notBetween": "notBetween",
        "notEmpty": "notEmpty",
        "notEquals": "notEquals"
      }
    },
    "hideColumn": "hideColumn",
    "manageColumns": "manageColumns",
    "noDataMessage": "noDataMessage",
    "noDataTitle": "noDataTitle",
    "pinColumn": "pinColumn",
    "rowsPerPage": "Filas por página",
    "showColumn": "showColumn",
    "total": "Total: ",
    "unpinColumn": "unpinColumn",
    "views": {
      "add": {
        "error": {
          "message": "Error al crear la vista",
          "title": "Error al crear la vista"
        },
        "success": {
          "message": "Vista creada exitosamente",
          "title": "Vista creada"
        }
      },
      "delete": {
        "error": {
          "message": "Error al eliminar la vista",
          "title": "Error al eliminar la vista"
        },
        "modal": {
          "cancel": "Cancelar",
          "delete": "Eliminar",
          "description": "¿Estás seguro de que quieres eliminar la vista {{viewName}} ? Esta acción es irreversible.",
          "title": "Confirmación"
        },
        "success": {
          "message": "Vista eliminada exitosamente",
          "title": "Vista eliminada"
        }
      },
      "modal": {
        "description": "Guarda la vista activa de la tabla de datos para acceder a ella más tarde. El ordenamiento, filtrado y configuración de columnas se guardarán.",
        "pinnedToDashboard": {
          "label": "label",
          "tooltip": "tooltip"
        },
        "reset": "Reiniciar",
        "save": "Guardar (beta)",
        "title": "Vista activa (beta)",
        "update": "Actualizar"
      },
      "update": {
        "error": {
          "message": "Error al actualizar la vista",
          "title": "Error al actualizar la vista"
        },
        "success": {
          "message": "Vista actualizada exitosamente",
          "title": "Vista actualizada"
        }
      },
      "viewName": "Nombre de la vista",
      "viewNamePlaceholder": "Ingrese el nombre de la vista"
    }
  },
  "zodErrors": {
    "errorDefault": "errorDefault",
    "invalidEmail": "invalidEmail",
    "latitudeOutOfRange": "latitudeOutOfRange",
    "longitudeOutOfRange": "longitudeOutOfRange",
    "mustContainBothLatitudeAndLongitude": "mustContainBothLatitudeAndLongitude",
    "noSpecialCharacters": "noSpecialCharacters",
    "ValueTooLong": "ValueTooLong",
    "ValueTooShort": "ValueTooShort"
  }
}
